module.exports = "../dist/img/1.d940.jpeg";